import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=0428a9fc"
import script from "./confirmation.vue?vue&type=script&lang=ts"
export * from "./confirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports